module.exports = __webpack_public_path__ + "img/steel.6d4cfc54.jpg";